export const MARKET_TO_MARKET_CONTENT_SX = {
    width: "100%",
    p: 3,
    boxSizing: "border-box",
    color: "primary.white70",
    "& .MuiPaper-root": {
        // backgroundColor: "background.chart",
        backgroundImage: "none",
        // border: "1px solid rgba(255, 255, 255, 0.12)",
        borderRadius: 0,
        overflow: "hidden",
    },
    "& .MuiInputBase-root, & .MuiFormLabel-root, & .MuiTypography-root": { color: "primary.white70" },
    "& .MuiOutlinedInput-notchedOutline": { borderColor: "input.borderColor.primary" },
    "& .MuiSvgIcon-root": { color: "icon.main" },
    "& .modebar": { opacity: 0.75 },
}
